import React, { Component, Fragment } from "react";
import { Row } from "reactstrap";

import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../../containers/navs/Breadcrumb";

import LogisticsVehicles from "../../../containers/pages/logistics/logistics-vehicles";

class PagesLogistics extends Component {
  render() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb heading="menu.logistics" match={this.props.match} />
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        <LogisticsVehicles />
      </Fragment>
    );
  }
}

export default PagesLogistics;
